import { useEffect, useState, useRef } from 'react';

export default function useLocalStorageState(
  key,
  defaultValue = '',
  { serialize = JSON.stringify, deserialize = JSON.parse } = {}
) {
  const getStorageValue = () => {
    const valueInLocalStorage = window.localStorage.getItem(key);
    if (valueInLocalStorage) {
      try {
        return deserialize(valueInLocalStorage);
      } catch (error) {
        window.localStorage.removeItem(key);
      }
    }
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
  };
  const [isInitialized, setIsInitialized] = useState(false);
  const [state, setState] = useState(defaultValue);

  const prevKeyRef = useRef(key);

  useEffect(() => {
    if (!isInitialized) return;
    const prevKey = prevKeyRef.current;
    if (prevKey !== key) {
      window.localStorage.removeItem(prevKey);
    }
    prevKeyRef.current = key;
    window.localStorage.setItem(key, serialize(state));
  }, [key, state, serialize]);

  useEffect(() => {
    setState(getStorageValue());
    setIsInitialized(true);
  }, []);

  return [state, setState];
}
